export default "__VITE_ASSET__CyJXIiHP__"